export default __webpack_public_path__ + "static/media/algo.32351035.png";